import firebase from 'firebase/app';
import db from '../firebaseInit';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const incrementNumTimesBoardPlayed = boardId => {
  const user = firebase.auth().currentUser;
  db.collection('users')
    .doc(user.uid)
    .collection('personalBests')
    .doc(boardId)
    .update({
      numTimesPlayed: firebase.firestore.FieldValue.increment(1),
    })
    .then(() => {})
    .catch(err => {
      this.$snotify.error('Error incrementing num times played', '', NOTIFICATION_SETTINGS);
    });
};

export default incrementNumTimesBoardPlayed;
